export const actions = {
  LOGIN_AUTH_TOKEN: 'LOGIN:AUTH_TOKEN',
  LOGIN_FORGOT_PASSWORD: 'LOGIN:FORGOT_PASSWORD',
  LOGIN_RESET_PASSWORD: 'LOGIN:RESET_PASSWORD'
};
